// extracted by css-extract-rspack-plugin
export default {"regulatoryComplianceToggles":"XLXnvvmOfvIL6ZKn","label":"MeSawXgC3eQZyxDs","toggle":"z6lRKa5BK6k0oihk","description":"YFWTsAjZhg0e45jb"};